import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { MainText } from "./MainText";
import { Box } from "./Box/MainBox/MainBox";
import theme from "app/Theme/Theme";
import ArrowRightSlider from "../Icons/ArrowSlider/ArrowRightSlider";
import normalize from "app/utils/normalize";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    flex: 1,
    paddingVertical: 20,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

interface Props {
  text: string;
  onPress: () => void;
  icon?: any;
  testID?: string;
}

const RedirectSelection = ({ text, onPress, icon, testID = "" }: Props) => {
  return (
    <TouchableOpacity
      testID={testID}
      style={styles.container}
      onPress={onPress}
    >
      {icon && (
        <MainText variant="l4-medium" marginRight="m">
          {icon}
        </MainText>
      )}
      <Box
        flex={1}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <MainText variant="l4-medium">{text}</MainText>
        <ArrowRightSlider
          width={normalize(15)}
          height={normalize(15)}
          color={theme.colors["neutral.900"]}
        />
      </Box>
    </TouchableOpacity>
  );
};

export { RedirectSelection };
